<script>
export default {
  name: "DeleteButtonRenderer",
  props: ['params'],
  methods: {
    onClicked() {
      this.params.onClicked(this.params);
    }
  }
}
</script>

<template>
  <button class="text-red-500 hover:text-red-700" @click="onClicked">✖</button>
</template>

<style scoped>

</style>